import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import CategoryLayer from "../../components/Category/CategoryLayer";

const CategoryPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Categories" />

        <CategoryLayer />
      </MasterLayout>
    </>
  );
};

export default CategoryPage;
